import React, { useEffect, useRef } from "react";
import { useTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useStyles } from "./TakisBackgroundVideoPlayer.styles";
const TakisBackgroundVideo = ({
  inlineVideos,
  altText,
  userPaused,
  isActive
}) => {

  const theme = useTheme();
  const classes = useStyles();
  const videoElement = useRef();
  const mdBreak = useMediaQuery(
    theme.breakpoints.up(theme.breakpoints.values.md)
  );

  const desktopVideoPlayer = (
    inlineVideos.desktopVideo &&
    <video className={classes.inlineVideo}
      loop
      autoPlay
      muted
      playsInline
      ref={videoElement}
      src={inlineVideos.desktopVideo}
      >
    </video>
  )
  const mobileVideoPlayer = (
    inlineVideos.mobileVideo &&
    <video className={classes.inlineVideo}
      loop
      autoPlay
      muted
      playsInline
      ref={videoElement}
      src={inlineVideos.mobileVideo}
      />
  )

  useEffect(()=>{
    if (isActive && !userPaused && videoElement.current) {
      videoElement.current.play()
    } else if ((!isActive || userPaused) && videoElement.current) {
      videoElement.current.pause()
    }
    return () => {
      if (videoElement.current) {
        videoElement.current.play()
      }
    }
  }, [isActive, userPaused, videoElement])

  const player = mdBreak
    ? desktopVideoPlayer
    : mobileVideoPlayer

  return (
    <div className={classes.backgroundPlayer}>
      { player }
    </div>
  )
};


TakisBackgroundVideo.propTypes = {
  videoClass: PropTypes.string,
  videos: PropTypes.object,
  altText: PropTypes.string,
  isActive: PropTypes.bool
};

export default TakisBackgroundVideo;
